export default {
    version: "309",
    buildNumber: "586",
    baseUrl: "https://cf-st.sc-cdn.net/d/r38Sk7x9s1MK7V7P6U2SZ?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
